// extracted by mini-css-extract-plugin
export default {"table":"ads_table__UJ6eg","linkTable":"ads_linkTable__Ac77t"};